var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grm-simple-select-component" }, [
    _c("div", { staticClass: "grm-simple-select-wrapper" }, [
      _c(
        "select",
        {
          staticClass: "grm-simple-select",
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event.target.value)
            },
          },
        },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "option",
            {
              key: i,
              domProps: {
                value: option.value,
                selected: option.value == _vm.value,
              },
            },
            [_vm._v(_vm._s(option.title))]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }